// currentShow.js — qué programa está en antena.
//
// 🔴 **La fuente ya NO es WordPress** (26.08.26). Estos datos salen del servidor
// de la radio, `listen.astra.fm/programas.json`, que es donde el equipo los
// edita. Ver `services/programmes.js` y el contrato del servidor.
//
// Este módulo se queda como capa de compatibilidad: media web llama a
// `getCurrentShow(preloaded, stationId)` y no tiene por qué enterarse del
// cambio. Los dos argumentos sobreviven y no se usan:
//
//   · `preloadedData` era el volcado de WordPress. El servicio nuevo ya cachea
//     cinco minutos por su cuenta, así que no hace falta pasarle nada.
//   · `stationId` seleccionaba la parrilla por ÍNDICE dentro del array de
//     WordPress —la trampa que ficha AGENTS.md—. Con una sola emisora ya no
//     significa nada, y de paso desaparece la posibilidad de anunciar el
//     programa equivocado sin dar ningún error.
import { getCurrentProgramme } from "@/services/programmes";

/**
 * @returns {Promise<object|null>} El programa en antena, o `null` si ninguno
 * cubre esta hora — que con los nueve actuales no pasa, porque cubren las 24 h.
 */
export async function getCurrentShow() {
  const p = await getCurrentProgramme();
  if (!p) return null;

  return {
    // Forma de siempre, para que las vistas no cambien.
    name: p.name,
    range: p.range,
    generos: p.genres,
    subGeneros: [],
    // `subtitle` era la descripción larga de WordPress. Ahora el residente es
    // un campo propio, así que esto deja de ser el sitio donde meterlo.
    subtitle: p.resident,
    image: p.image,
    description: p.description,
    startTime: p.startTime,
    endTime: p.endTime,
    // Campos nuevos del contrato del servidor.
    slug: p.slug,
    genre: p.genre,
    resident: p.resident,
    residentImage: p.residentImage,
    days: p.days,
  };
}
